'use strict';

var _ = require('lodash');
var FaresOptimizerRejectModalDirective = function FaresOptimizerRejectModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-optimizer-reject-modal.html'),
    controller: 'FaresOptimizerRejectModalController',
    scope: {
      rejectCallback: '=',
      showRejectModal: '=',
      rejectModalData: '='
    },
    link: function link($scope, $element) {
      $scope.$watch('showRejectModal', function (newVal) {
        if (newVal) {
          $scope.selectedItemCount = $scope.rejectModalData.count;
          $scope.handleResetState();
          if ($scope.rejectModalData.ladderIds !== undefined) {
            $scope.fareRecommendationRecordKeyList = $scope.rejectModalData.ladderIds;
          }
          $element.modal('show');
          $scope.entryLevelFbcList = _.uniq($scope.rejectModalData.entryLevelFbcs);
          $scope.showRejectModal = false;
        }
      });
    }
  };
};
FaresOptimizerRejectModalDirective.$inject = [];
module.exports = FaresOptimizerRejectModalDirective;